import React from 'react';
import { connect } from "react-redux";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import { RoutingConstants } from '../../constants';
import isTokenExpired from '../../utils/isTokenExpired';
import { logOut } from '../../store/actions/auth';
import localCacheStorage from '../../utils/localCacheStorage';
import { savePostLoginRedirect } from '../../utils/postLoginRedirect';

const ProtectedRoute = (props) => {
  const {
    accessToken,
    tokenExpires
  } = props;
  const location = useLocation();
  const isValidToken = isTokenExpired(tokenExpires);
  const eula = localStorage.getItem("eula");
  if (!accessToken || eula) {
    localCacheStorage.clear("APP_STATE");
    localCacheStorage.clear("isFilter");
    localCacheStorage.clear("filters");
    localCacheStorage.clear("searchTags");
    localStorage.clear();
    localCacheStorage.clear();
    savePostLoginRedirect(`${location.pathname}${location.search}`);
    return (
      <Navigate to={RoutingConstants.login} />
    )
  }
  if (accessToken && isValidToken) {
    return (
      <Outlet />
    )
  }
  localCacheStorage.clear("APP_STATE");
  localCacheStorage.clear("isFilter");
  localCacheStorage.clear("filters");
  localCacheStorage.clear("searchTags");
  localStorage.clear();
  localCacheStorage.clear();
  savePostLoginRedirect(`${location.pathname}${location.search}`);
  return (
    <Navigate to={RoutingConstants.login} />
  )
};

const mapStateToProps = (state) => {
  return {
    loggedIn: state.auth.loggedIn,
    accessToken: state.auth.loginDetails?.access_token,
    tokenExpires: state.auth.loginDetails?.token_expires || ''
  };
};

const mapDispatchToProps = {
  triggerLogout: logOut
};

export default connect(mapStateToProps, mapDispatchToProps)(ProtectedRoute);
